import Backbone from 'backbone';
import $ from 'jquery';

import {CreateAssemblyModal} from 'assembly/CreateAssemblyModal';
import runModal from 'ui-library/runModal';
import ifCreateFromHash from 'util/ifCreateFromHash';

class CreateAssemblyLink extends Backbone.View<Backbone.Model> {
  render(): this {
    $(document).on('click', '.js-create-new-assembly', (e) => {
      e.preventDefault();
      runModal(CreateAssemblyModal, {});
    });

    ifCreateFromHash('#create/assembly', () => {
      runModal(CreateAssemblyModal, {});
    });
    return this;
  }
}

export default CreateAssemblyLink;
